import type { LocalStorageContextProps } from '../Contexts/LocalStorageContext';
import type { ModeContextProps } from '../Contexts/ModeContext';
import type { SystemContextProps } from '../Contexts/SystemContext';
import type { TokenContextProps } from '../Contexts/TokenContext';
import type { UserContextProps } from '../Contexts/UserContext';
import Mode from '../Enums/Mode';

export function handleLogout(systemContext: SystemContextProps, tokenContext: TokenContextProps, userContext: UserContextProps, modeContext: ModeContextProps | null, localStorageContext: LocalStorageContextProps): void {

    userContext.setCurrentUser(null);
    localStorageContext.localStorageService?.clearCurrentUser();

    userContext.setLastActivity(null);
    localStorageContext.localStorageService?.clearLastActivity();

    modeContext?.setMode(Mode.LOGIN);
    localStorageContext.localStorageService?.setMode(Mode.LOGIN);

    systemContext.setApiVersion(null);
    
    systemContext.setMinAppVersion(null);

    tokenContext.setToken(null);
    localStorageContext.localStorageService?.setToken(null);

    tokenContext.setExpiration(null);
    localStorageContext.localStorageService?.setExpiration(null);
}